import { z } from 'zod';
import { userPermissionsSchema } from './permissions.js';
export const toolOutcomeSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('inline'),
        value: z.unknown(),
        shape: z.string().optional(),
    }),
    z.object({
        kind: z.literal('external'),
        ref: z.string(),
        hash: z.string(),
        size: z.number().int().nonnegative(),
        preview: z.string(),
    }),
    z.object({
        kind: z.literal('failed'),
        message: z.string(),
        code: z.string().optional(),
    }),
]);
export const MAX_ATTACHMENTS_PER_QUESTION = 5;
export const agentAttachmentSchema = z.object({
    id: z.string(),
    name: z.string(),
    mimeType: z.string(),
});
export const agentAttachmentUploadResponseSchema = z.discriminatedUnion('success', [
    z.object({ success: z.literal(true), attachment: agentAttachmentSchema }),
    z.object({ success: z.literal(false), error: z.string() }),
]);
export const agentEntrySchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('user_message'),
        text: z.string(),
        attachments: z.array(agentAttachmentSchema).optional(),
    }),
    z.object({ kind: z.literal('model_message'), text: z.string() }),
    z.object({
        kind: z.literal('tool_call'),
        callId: z.string(),
        name: z.string(),
        args: z.unknown(),
    }),
    z.object({
        kind: z.literal('tool_outcome'),
        callId: z.string(),
        outcome: toolOutcomeSchema,
        elapsedMs: z.number().int().nonnegative().optional(),
    }),
    z.object({
        kind: z.literal('compaction'),
        text: z.string(),
        throughId: z.number().int().nonnegative(),
    }),
    z.object({ kind: z.literal('memory_set'), key: z.string(), value: z.string() }),
    z.object({ kind: z.literal('memory_cleared'), key: z.string() }),
]);
export const AGENT_ENTRY_KINDS = nonEmpty(agentEntrySchema.options.map((option) => option.shape.kind.value));
function nonEmpty(items) {
    const [first, ...rest] = items;
    if (first === undefined)
        throw new Error('Expected at least one item.');
    return [first, ...rest];
}
export const turnGaveUpSchema = z.discriminatedUnion('reason', [
    z.object({ reason: z.literal('exchangesSpent'), exchanges: z.number().int().nonnegative() }),
    z.object({
        reason: z.literal('stuck'),
        repeatedError: z.string(),
        times: z.number().int().positive(),
    }),
    z.object({ reason: z.literal('silent') }),
    z.object({ reason: z.literal('chatFailed'), message: z.string() }),
    z.object({ reason: z.literal('outOfTime'), elapsedMs: z.number().int().nonnegative() }),
]);
export const agentTurnOutcomeSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('replied') }),
    z.object({ kind: z.literal('gaveUp'), why: turnGaveUpSchema }),
    z.object({ kind: z.literal('failed'), message: z.string() }),
]);
export const AGENT_TURN_STATUSES = ['queued', 'running', 'finished'];
export const agentTurnStatusSchema = z.enum(AGENT_TURN_STATUSES);
export const agentScopeSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('inherit') }),
    z.object({ kind: z.literal('within'), permissions: userPermissionsSchema }),
]);
export const INHERIT_AGENT_SCOPE = { kind: 'inherit' };
export const toolDeclarationSchema = z.object({
    name: z.string(),
    description: z.string(),
    parametersJsonSchema: z.record(z.string(), z.unknown()),
});
//# sourceMappingURL=agentConversation.js.map